import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import FullscreenWrapper from './FullscreenWrapper';

interface FullPageLoaderProps {
  title: string;
  message: string;
}

const FullPageLoader: React.FC<FullPageLoaderProps> = ({ title, message }) => {
  return (
    <FullscreenWrapper>
      <Box
        className="full-page-message"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="80%"
        textAlign="center"
      >
        <CircularProgress />
        <Typography variant="h2" component="h2" gutterBottom mt={3}>
          {title}
        </Typography>
        <Typography variant="body2" component="p" gutterBottom>
          {message}
        </Typography>
      </Box>
    </FullscreenWrapper>
  );
};

export default FullPageLoader;
